import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useToast } from 'hooks/ui';
import { approveBroadcast } from 'api/broadcasts.service';
import { setDraftBroadcast } from 'store/broadcast';
import { useApplicationStore } from 'store/application';
import { broadcastKeys } from './queryKeys';

export const useBroadcastApproveQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { setLoading, removeLoading } = useApplicationStore((state) => state);

  const { isPending, mutate } = useMutation({
    mutationFn: (id: string) => {
      setLoading();

      return approveBroadcast(id);
    },
    onSuccess: (broadcast) => {
      toast.success('Broadcast has been approved successfully');
      setDraftBroadcast(broadcast);
    },
    onError: (error: AxiosError) => toast.error(error.message),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: broadcastKeys.all });
      removeLoading();
    },
  });

  return { isLoading: isPending, mutate };
};
